// Core
import { 
  Route, 
  Switch, 
  Redirect, 
  useRouteMatch, 
} from 'react-router-dom';

// Chakra imports
import { 
  Box,
} from '@chakra-ui/react';

// Components
import Partner from './Partner';
import PartnersEdit from './PartnersEdit';

function Partners(props) {
  const { path } = useRouteMatch();

  return (
    <>
      <Box>
        <Switch>
          <Route path={`${path}/:id(new|\\d+)`} render={() => <PartnersEdit/>}/>
          <Route path={`${path}`} render={() => <Partner/>}/>
          <Redirect from={`${path}*`} to={`${path}`} />
        </Switch>
      </Box>
    </>
  );
}

export default Partners;